import mongoose from "mongoose";
import { nanoid } from "nanoid";
import { match } from "@mssi/pssp-shared";

export interface CategoryBundleId {
  contractId: string;
  bundleId: string | number;
}

export interface Category {
  _id: mongoose.Schema.Types.ObjectId;
  /** @deprecated */
  id?: string;
  customerId: string;
  categoryName: string;
  bundleIds: CategoryBundleId[];
  /** @deprecated */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  bundles: any[];
}

export const CategorySchema = new mongoose.Schema<Category>({
  /** @deprecated */
  id: { type: String, index: true, default: () => nanoid() },
  customerId: String,
  categoryName: String,
  bundleIds: [{
    _id: false,
    contractId: String,
    bundleId: mongoose.Schema.Types.Mixed,
  }],
  /** @deprecated */
  bundles: [Object],
});

export const props: (keyof Category)[] = [
  "customerId",
  "categoryName",
];

export function matches(a: Category, b: Category) {
  return match(a, b, props);
}

export const categoryUtils = {
  props,
  matches,
};
